export default __webpack_public_path__ + "static/media/BranchialIndex.ced7f716.svg";